import { render, staticRenderFns } from "./MonstersList.vue?vue&type=template&id=697d8025&lang=pug&"
import script from "./MonstersList.vue?vue&type=script&lang=ts&"
export * from "./MonstersList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports